export default __webpack_public_path__ + "static/media/atg.5c177d4c.svg";